import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[ViEllipsis]',
  providers: [MatTooltip],
  standalone: true,
})
export class ViEllipsisDirective implements AfterViewInit, OnDestroy {
  @Input() showTextContentInTooltip: boolean = false;
  @Input() includeHeight: boolean = false;
  domElement: any;
  listener: any;

  constructor(
    private elementRef: ElementRef,
    private tooltip: MatTooltip,
    private renderer2: Renderer2
  ) {
    this.listener = this.renderer2.listen('window', 'scroll', () => {
      if (this.showTextContentInTooltip) {
        this.tooltip.hide();
      }
    });
    this.domElement = this.elementRef.nativeElement;
  }

  ngAfterViewInit(): void {
    this.init();
  }

  ngOnDestroy(): void {
    this.listener();
  }

  @HostListener('window:resize', ['$event.target'])
  init() {
    if (this.isEllipsisDetected()) {
      this.domElement.classList.add('ellipsis');
      this.setTooltipMessage(this.domElement.textContent);
    } else {
      this.domElement.classList.remove('ellipsis');
      this.setTooltipMessage('');
    }
  }

  @HostListener('mouseover') mouseover() {
    if (this.showTextContentInTooltip) {
      this.tooltip.show();
    }
  }

  @HostListener('mouseleave') mouseleave() {
    if (this.showTextContentInTooltip) {
      this.tooltip.hide();
    }
  }

  private setTooltipMessage(message: string) {
    if (this.showTextContentInTooltip) {
      this.tooltip.message = message;
    }
  }

  private isEllipsisDetected(): boolean {
    return this.includeHeight
      ? this.domElement.clientWidth < this.domElement.scrollWidth ||
          this.domElement.clientHeight < this.domElement.scrollHeight
      : this.domElement.clientWidth < this.domElement.scrollWidth;
  }
}
